import { createApp } from 'vue'
import VueGtag from "vue-gtag-next";
import App from './App.vue'

const app = createApp(App);

app.use(VueGtag, {
  property: {
    id: "G-S2SBQP2D6W",
    useDebugger: process.env.NODE_ENV !== "production"
  }
});

app.mount("#app");
